import { Component, Input, Output, EventEmitter, OnChanges } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { NotificationService } from '@app/core/services/notification.service';
import { ContextService } from '@core/context/services/context.service';
import { AvaliacaoService } from '@core/config/services/avaliacao.service';

@Component({
  selector: 'app-data-exames-conselho-modal',
  templateUrl: './data-exames-conselho-modal.component.html'
})
export class DataExamesConselhoModalComponent implements OnChanges {
  @Input() isOpen = false;
  @Input() colunas: any[] = [];
  @Input() linhas: any[] = [];
  @Input() turmaId: number | null = null;
  @Input() itemEducacionalId: number | null = null;
  
  @Output() fechado = new EventEmitter<void>();

  itens: any[] = [];

  constructor(
    private avaliacaoService: AvaliacaoService,
    private notificationService: NotificationService,
    private contextService: ContextService
  ) {}

  ngOnChanges() {
    if (this.isOpen) {
      this.mapearItens();
    }
  }

  private mapearItens(): void {
    this.itens = [];
    this.colunas.forEach((col, index) => {
      if (col.tipoPeriodo !== 'PERIODO_AVALIATIVO' && 
    col.tipoPeriodo !== 'MEDIA_FINAL' && 
    col.tipoPeriodo !== 'CALCULO_INSTRUMENTOS' && 
    col.tipoPeriodo !== 'MEDIA_PERIODO') {
        let notaRef = null;
        for (const linha of this.linhas) {
          if (linha.notas && linha.notas[index] && linha.notas[index].avaliavel) {
            notaRef = linha.notas[index];
            break;
          }
        }
        if (notaRef && notaRef.avaliavel) {
          this.itens.push({
            descricao: col.descricao || col.tipoPeriodo,
            id: Number(notaRef.avaliavel.id),
            data: notaRef.avaliavel.data || null,
            tipoPeriodo: col.tipoPeriodo,
            notaRef: notaRef,
            salvando: false
          });
        }
      }
    });
  }

  converterStringParaData(dataStr: string | null | undefined): Date | null {
    if (!dataStr) return null;
    const partes = dataStr.split('-');
    if (partes.length !== 3) return null;
    const [ano, mes, dia] = partes.map(Number);
    return new Date(ano, mes - 1, dia, 12, 0, 0);
  }

  onDataAlterada(item: any, novaData: Date | null): void {
    const dataAnterior = item.data;
    if (!novaData) {
      item.data = null;
    } else {
      const ano = novaData.getFullYear();
      const mes = String(novaData.getMonth() + 1).padStart(2, '0');
      const dia = String(novaData.getDate()).padStart(2, '0');
      item.data = `${ano}-${mes}-${dia}`;
    }

    if (dataAnterior !== item.data) {
      this.salvar(item, dataAnterior);
    }
  }

  private salvar(item: any, dataAnterior: string | null): void {
    if (!this.turmaId || !this.itemEducacionalId) return;

    item.salvando = true;

    this.avaliacaoService.salvarDataExameConselho(this.turmaId, this.itemEducacionalId, item).subscribe({
      next: (res: any) => {
        item.salvando = false;
        this.atualizarDadosLocais(item, res);
        this.notificationService.success({ title: 'Sucesso', message: 'Data alterada com sucesso.' });
      },
      error: (err: HttpErrorResponse) => {
        item.salvando = false;
        item.data = dataAnterior;

        const erroDetail = err.error?.detail ? Object.values(err.error.detail)[0] : null;
        const mensagemErro = erroDetail || err.error?.message || 'Não foi possível alterar a data.';

        this.notificationService.error({ title: 'Atenção', message: String(mensagemErro) });
      }
    });
  }

  private atualizarDadosLocais(item: any, res: any): void {
    if (!item.notaRef?.avaliavel) return;

    item.notaRef.avaliavel.data = item.data;
    const novoDados = Array.isArray(res) ? res.find((r: any) => r.tipoPeriodo === item.tipoPeriodo) : res;

    if (novoDados) {
      Object.assign(item.notaRef.avaliavel, novoDados);
    }
  }

  onClose(): void {
    this.isOpen = false;
    this.fechado.emit();
  }
}
